import React from 'react';
import c from 'classnames';

interface Props {
    title: React.ReactNode;
    colour?: 'PURPLE' | 'GREY' | 'YELLOW' | 'RED' | 'GREEN';
    small?: boolean;
}

export function Pill({ title, colour = 'PURPLE', small = false }: Props) {
    return (
        <span
            className={c('inline-flex text-white rounded-full justify-center items-center whitespace-nowrap', {
                'bg-wedgewood-600': colour === 'PURPLE',
                'bg-gray-600': colour === 'GREY',
                'bg-yellow-600': colour === 'YELLOW',
                'bg-red-600': colour === 'RED',
                'bg-green-600': colour === 'GREEN',
                'text-sm h-4 px-2': small,
                'text-sm xl:text-base h-6 px-3': !small,
            })}
        >
            {title}
        </span>
    );
}
